module.exports = __webpack_public_path__ + "img/Equipamentos.1fcdf561.jpg";